module.exports = {
	"flowers": [
		"anemone",
		"amaryllis",
		"amaranth",
		"aster",
		"azalea",
		"babys breath",
		"begonia",
		"bellflower",
		"bergamot",
		"bird of paradise",
		"bluebell",
		"bottlebrush",
		"buttercup",
		"camellias",
		"carnation",
		"chrysantemum",
		"columbine",
		"clover",
		"crocus",
		"daisy",
		"dahlia",
		"daffodil",
		"delphinium",
		"edelweiss",
		"primrose",
		"forget me not",
		"foxglove",
		"freesia",
		"gerbera daisy",
		"gladiolus",
		"hibiscus",
		"heather",
		"hyacinth",
		"holly",
		"iris",
		"jasmine",
		"ladys slipper",
		"lavender",
		"lilac",
		"lily",
		"lotus flower",
		"marigold",
		"marjoram",
		"mimosa",
		"narcissus",
		"orange blossom",
		"orchid",
		"peach blossom",
		"peony",
		"petunia",
		"rhododendron",
		"rosemary",
		"roses",
		"sage",
		"snapdragon",
		"sunflower",
		"tansy",
		"thistle",
		"thyme",
		"tulip",
		"violet",
		"water lily",
		"zinnia"
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/plants/flowers.json
 **/